import queryString from 'query-string';

import { getEncryptValue } from '@/utils';
import { API2_HOST, DEFAULT_CAPTCHA_CONFIG } from '@/utils/constants';
import { SUB_ACCOUNT_LOGIN_CAPTCHA_SCENE } from '@/utils/constants/sub-account';

import fetchData from './http';
import request from './request';

export function registerPermisson() {
  const url = `${API2_HOST}/register/permission_v2`;
  return request.get(url, { useCache: true }).then((res: any) => {
    const obj = res?.result || {
      code: '',
      name_en: '',
      is_login: false,
      is_visible: 0,
    };
    return obj;
  });
}
export const getOauthTVParams = (params: any = {}) => {
  try {
    const parsed = queryString.parse(window.location?.search) || {};
    if (parsed?.client_id) {
      params.oauth_tmp_login_id = parsed?.client_id;
    }
  } catch (e) {
    console.warn(e);
  }
  return params;
};
export function childLogin(params: any) {
  const url = `${API2_HOST}/v3/auth/login`;
  return new Promise((resolve, reject) => {
    getEncryptValue(getOauthTVParams(params)).then((res: any) => {
      fetchData
        .post<any>(url, { body: JSON.stringify(res) })
        .then((resp: any) => {
          resolve(resp);
          // const { ...userInfo } = resp.result;
          // if (resp.ext_code) {

          // }
          // resolve({
          //   ...userInfo,
          //   currentSite: resp?.currentSite,
          // });
        })
        .catch((error) => {
          reject(error.response ? error.response.data : error);
        });
    });
  });
}
export const getRealCookieConfig = (initConfig: any) => {
  const sceneList = [SUB_ACCOUNT_LOGIN_CAPTCHA_SCENE];
  const cookieRealConfig = {};
  const isGray: any = localStorage.getItem('completelyUseMagpieCatcha');
  sceneList.forEach((scene) => {
    cookieRealConfig[scene] = {
      completelyUseMagpieCatcha: isGray
        ? isGray === 'true'
        : initConfig[scene]?.completelyUseMagpieCatcha ??
          initConfig?.default?.completelyUseMagpieCatcha ??
          false,
      useDowngrade:
        initConfig[scene]?.useDowngrade ??
        initConfig?.default?.useDowngrade ??
        true,
      guidTailList:
        isGray && isGray !== 'true'
          ? []
          : initConfig[scene]?.guidTailList ??
            initConfig?.default?.guidTailList ??
            [],
      oldCapchaList:
        initConfig[scene]?.oldCapchaList ??
        initConfig?.default?.oldCapchaList ??
        [],
    };
  });
  return cookieRealConfig;
};
// 获取行为验证相关的配置
export const getCaptchaConfig = () => {
  const DEADPOOL_CONFIG = `${API2_HOST}/v3/config/web`;

  return new Promise((resolve, reject) => {
    fetchData
      .post(DEADPOOL_CONFIG, {
        body: JSON.stringify({
          project_name: 'bybit.us',
          keys: ['cht.captcha.config'],
        }),
      })
      .then((res = {}) => {
        const {
          result: { data = [] },
        } = res as any;

        const cookieConfig = JSON.parse(data[0]?.value);

        resolve(getRealCookieConfig(cookieConfig));
      })
      .catch(() => {
        resolve(getRealCookieConfig(DEFAULT_CAPTCHA_CONFIG));
      });
  });
};

export const getUserTag = (params: string[]) => {
  const url = params.reduce((url, reqParam, index) => {
    const params = `${index === 0 ? '?' : '&'}req_tags=${reqParam}`;
    return url + params;
  }, `${API2_HOST}/user/private/user-tag`);

  return request.get<{ result: { user_tags: { [key: string]: any } } }>(url, {
    useCache: true,
  });
};

export const requestRegulationInfo = async () => {
  return request.get(`${API2_HOST}/compliance/v1/wall/regulation-info`, {
    useCache: true,
  });
};
